import useAppContext from "context/AppContext";
import Superadmin from "./components/Superadmin";
import Admin from "./components/Admin";
import Finance from "./components/Finance";
import Courier from "./components/Courier";
import Server from "./components/Server";
import Manager from "./components/Manager";
import Packing from "./components/Packing";

const Dashboard = () => {
    const { userDetail } = useAppContext();
    const role = userDetail?.role?.toUpperCase();

    const dashboardMap = {
        SUPERADMIN: <Superadmin />,
        ADMIN: <Admin />,
        FINANCE: <Finance />,
        COURIER: <Courier />,
        SERVER: <Server />,
        MANAGER: <Manager />,
        PACKING: <Packing />
    };

    return (
        <div className="flex flex-col gap-6">
            {dashboardMap[role] || <div>Role tidak dikenali</div>}
        </div>
    );
};

export default Dashboard;